import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
  type InputSignal,
  type OutputEmitterRef,
  type Signal,
} from '@angular/core';

@Component({
  selector: 'ui-list-row',
  imports: [],
  templateUrl: './ui-list-row.component.html',
  styleUrl: './ui-list-row.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiListRowComponent {
  public readonly title: InputSignal<string> = input.required<string>();
  public readonly subtitle: InputSignal<string | null> = input<string | null>(null);
  public readonly meta: InputSignal<string | null> = input<string | null>(null);
  public readonly disabled: InputSignal<boolean> = input<boolean>(false);
  public readonly dense: InputSignal<boolean> = input<boolean>(false);
  public readonly selected: OutputEmitterRef<void> = output<void>();

  protected readonly hasSubtitle: Signal<boolean> = computed((): boolean => !!this.subtitle());
  protected readonly hasMeta: Signal<boolean> = computed((): boolean => !!this.meta());

  protected handleSelected(event: MouseEvent): void {
    if (this.disabled()) {
      event.preventDefault();
      return;
    }

    this.selected.emit();
  }
}
